import "./UserVerification.css";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useSnackbar } from "notistack";
import { MenuItem, TextField } from "@mui/material";
import { Preferences } from "@capacitor/preferences";
import axios from "axios";
import { Typography, Button } from "@mui/material";
// Components
import IonicPageWrapper from "../../components/IonicPageWrapper/IonicPageWrapper";
import StandardButton from "../../components/StandardButton/StandardButton";
import StandardTextfield from "../../components/StandardTextfield/StandardTextfield";

function UserVerification() {
  const history = useHistory();
  const { pathname } = useLocation();

  const { enqueueSnackbar } = useSnackbar();
  const [verificationData, setVerificationData] = useState({
    first_name: "",
    classid: "",
    phone_no: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [allClassData, setAllClassData] = useState([]);

  useEffect(() => {
    if (pathname === "/signup") {
      fetchAllClass();
      setBtnLoading(false);
      setVerificationData({ first_name: "", classid: "", phone_no: "" });
    }
  }, [pathname]);

  const fetchAllClass = async (e) => {
    const { value } = await Preferences.get({
      key: "gjaai_user_schoolid",
    });

    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`, {
        schoolid: value,
      })
      .then((res) => {
        if (res.data.success) {
          setAllClassData(res.data.data);
        } else {
          enqueueSnackbar("Error Fetching Class, Try Again !!!", {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { value } = await Preferences.get({
      key: "gjaai_num10digit",
    });
    const { phone_no } = verificationData;
    if (Object.values(verificationData)?.includes(""))
      return enqueueSnackbar("Please Fill All The Details !!!", {
        variant: "error",
      });
    // Validate phone number length
    if (value === "false") {
      if (phone_no.length !== 10 || isNaN(phone_no)) {
        return enqueueSnackbar(
          "Please enter a valid 10-digit phone number !!!",
          {
            variant: "error",
          }
        );
      }
    }
    setBtnLoading(true);

    try {
      const body = {
        ...verificationData,
        schoolid: (await Preferences.get({ key: "gjaai_user_schoolid" })).value,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/addformuser`,
        body
      );

      if (res.data.success) {
        enqueueSnackbar(" Registration Successful", {
          variant: "success",
        });
        Preferences.set({
          key: "gjaii_IDCARD_user",
          value: JSON.stringify(res.data.data),
        });
        Preferences.set({
          key: "userMobile",
          value: verificationData.phone_no,
        });
        history.push("/home");
        return;
      }

      if (res.data.message === "Phone number already exists") {
        try {
          const loginRes = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/user/getuserbyphone`,
            { phone_no: verificationData.phone_no }
          );
          if (loginRes.data.success) {
            // Get stored school ID from preferences
            const { value: storedSchoolId } = await Preferences.get({
              key: "gjaai_user_schoolid",
            });
            
            // Check if user's school ID matches stored school ID
            if (loginRes.data.data.schoolid.toString() !== storedSchoolId.toString()) {
              enqueueSnackbar("You are not allowed to login for this school", {
                variant: "error",
              });
              setBtnLoading(false);
              return;
            }
            
            enqueueSnackbar("Login Successful", { variant: "success" });
            Preferences.set({
              key: "gjaii_IDCARD_user",
              value: JSON.stringify(loginRes.data.data),
            });
            Preferences.set({
              key: "userMobile",
              value: verificationData.phone_no,
            });
            history.push("/home");
            return;
          }
          enqueueSnackbar(loginRes.data.message || "Could not log in.", {
            variant: "error",
          });
        } catch (err) {
          console.log(err);
          enqueueSnackbar("Error during login, Please Try Again !!!", {
            variant: "error",
          });
        }
      } else {
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error, Please Try Again !!!", { variant: "error" });
    }
    setBtnLoading(false);
  };

  return (
    <IonicPageWrapper headerTitle="New User Details">
      <div id="verification">
        <section className="verification_cont">
          <form className="verification_form" onSubmit={handleSubmit}>
            <div>
              <StandardTextfield
                variant="outlined"
                label="Name"
                name="first_name"
                value={verificationData.first_name}
                setValue={setVerificationData}
                spreadValue={verificationData}
              />
              <StandardTextfield
                variant="outlined"
                label="Contact Number"
                type="number"
                name="phone_no"
                value={verificationData.phone_no}
                setValue={setVerificationData}
                spreadValue={verificationData}
                // disabled={true}
              />
              <TextField
                fullWidth
                select
                label="Select"
                value={verificationData.classid}
                onChange={(e) =>
                  setVerificationData({
                    ...verificationData,
                    classid: e.target.value,
                  })
                }
              >
                {allClassData?.map((c, i) => (
                  <MenuItem value={c?.classid} key={i}>
                    {c?.standard + " - " + c?.division}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <StandardButton label="Submit" type="submit" />
          </form>
        </section>
      </div>
    </IonicPageWrapper>
  );
}

export default UserVerification;
